import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { GoogleTagService } from '@app/services/google-tag-manager.service';
import { PaymentService } from '@app/services/payment.service';
import { VersionService } from '@app/services/version.service';
import { TriggerReleaseNotesComponent } from '@app/components/release-notes/trigger-release-notes/trigger-release-notes.component';
import { UserIconComponent } from '@app/profile/user-icon/user-icon.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-user-menu',
  imports: [TranslocoPipe, CommonModule, RouterLink, UserIconComponent, TriggerReleaseNotesComponent],
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent {
  authService = inject(AuthService);
  versionService = inject(VersionService);
  paymentService = inject(PaymentService);
  googleTagService = inject(GoogleTagService);

  isAdmin = computed(() => this.authService.userIsAdmin());
  subscriptionExpired = computed(() => this.paymentService.subscriptionExpired());
  gtmIsEnabled = computed(() => this.googleTagService.gtmIsEnabled());
}
